import React from "react";

/**
 * Row of small counters shown above a list, e.g. "12 Online · 8 Offline".
 * items: [{ label, value, tone: "default" | "success" | "danger" | "warning" | "info" }]
 */
const SummaryStrip = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <div className="summary-strip">
      {items.map(({ label, value, tone = "default" }) => (
        <div
          key={label}
          className={`summary-strip__item summary-strip__item--${tone}`}
        >
          <span className="summary-strip__value">{value}</span>
          <span className="summary-strip__label">{label}</span>
        </div>
      ))}
    </div>
  );
};

export default SummaryStrip;
